import React from 'react'
import { Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

export const Product = (props) => {
    console.log(props)
    const navigate = useNavigate();
    // console.log(props);
    for (let obj in props) {
        let item = obj

        if (item === 'soap') {
            let { id, imgUrl, content, title, price } = props.soap;
            return (
                <>
                    <Col md={3} onClick={() => { navigate('/detail/' + id) }}>
                        <img src={process.env.PUBLIC_URL + imgUrl} width="100%" />
                        <h6>{content}</h6>
                        <h4>{title}</h4>
                        <p>{price}원</p>
                    </Col>
                </>
            )

        } else if (item === 'incense') {
            let { imgUrl, content, title, price } = props.incense;
            return (
                <>
                    <Col md={3}>
                        <img src={process.env.PUBLIC_URL + imgUrl} width="100%" />
                        <h6>{content}</h6>
                        <h4>{title}</h4>
                        <p>{price}원</p>
                    </Col>
                </>
            )
        } else if (item === 'balm') {
            let { imgUrl, content, title, price } = props.balm;
            return (
                <>
                    <Col md={3}>
                        <img src={process.env.PUBLIC_URL + imgUrl} width="100%" />
                        <h6>{content}</h6>
                        <h4>{title}</h4>
                        <p>{price}원</p>
                    </Col>
                </>
            )
        } else if (item === 'candle') {
            let { imgUrl, content, title, price } = props.candle;
            return (
                <>
                    <Col md={3}>
                        <img src={process.env.PUBLIC_URL + imgUrl} width="100%" />
                        <h6>{content}</h6>
                        <h4>{title}</h4>
                        <p>{price}원</p>
                    </Col>
                </>
            )
        } else if (item === 'sample') {
            let { imgUrl, content, title, price } = props.sample;
            return (
                <>
                    <Col md={3}>
                        <img src={process.env.PUBLIC_URL + imgUrl} width="100%" />
                        <h6>{content}</h6>
                        <h4>{title}</h4>
                        <p>{price}원</p>
                    </Col>
                </>
            )
        }
    }


}
